var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlastLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215 215",
    style: {
      enableBackground: "new 0 0 215 215"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:none;stroke:#0074D6;stroke-miterlimit:10;}\n    .st1{fill:none;stroke:#51B0B0;stroke-miterlimit:10;}\n    .st2{fill:none;stroke:#A4C53E;stroke-miterlimit:10;}\n    .st3{fill:#FF0000;}\n    .st4{fill:#FFFF00;}\n    .st5{fill:none;stroke:#FF0000;stroke-miterlimit:10;}\n    .st6{fill:#FCFC03;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "161,106.4 190.3,91.8 200.4,60.8 180.2,46.1 45.7,46.1 14.6,69.2 172.7,69.2 164.3,95.2 100.9,95.2    94.8,114.2 158.2,114.2 140.4,168.9 170.1,154.2 180.7,121.4 160.8,106.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "59.3,145.4 77.6,88.4 57.3,73.2 26.8,168.9 140.4,168.9 148,145.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlastLogo);
export default __webpack_public_path__ + "static/media/blast-logo.0ba6036267fd27757c6c158a44d803d1.svg";
export { ForwardRef as ReactComponent };